<template>
    <div class="footer">
        <footer class="web">
            <div class="footer-top">
                <div class="left">
                    <h2>商务合作</h2>
                    <p>13269322718</p>
                    <p>bd@huijianzhilian.com</p>
                    <h2 class="address">公司地址</h2>
                    <p>
                        北京大兴天华北街11号富兴国际中心
                        <br>
                        杭州钱塘区通宇路89号
                    </p>
                </div>
                <div class="right">
                    <div class="footer-column">
                        <h3>首页</h3>
                        <a href="/#/index#container">公司简介</a>
                        <a href="/#/index#product">产品介绍</a>
                        <a href="/#/index#solution">解决方案</a>
                        <!-- <a href="/#/index#partner">合作伙伴</a> -->
                    </div>
                    <div class="footer-column">
                        <h3>产品</h3>
                        <a href="/#/products/XR1">XR1</a>
                        <a href="/#/products/VR1">VR1</a>
                        <a href="/#/products/XR2">XR2</a>
                        <a href="/#/products/VR2">VR2</a>
                    </div>
                    <div class="footer-column">
                        <h3>解决方案</h3>
                        <a href="/#/solutions/aviation">飞行</a>
                        <a href="/#/solutions/training">军体</a>
                        <a href="/#/solutions/industry">工业</a>
                        <a href="/#/solutions/lowAltitude">低空</a>
                    </div>
                    <div class="footer-column">
                        <h3>新闻资讯</h3>
                        <a href="/#/news">行业新闻</a>
                    </div>
                    <div class="footer-column">
                        <h3>技术支持</h3>
                        <a href="/#/support">技术支持</a>
                    </div>
                    <div class="footer-column">
                        <h3>关于我们</h3>
                        <a href="/#/about">公司简介</a>
                        <a href="/#/about#team">团队介绍</a>
                        <a href="/#/about#recruit">加入我们</a>
                    </div>
                    <div class="more">
                        <img src="../assets/image/code.png" alt="荟镜XR 慧建智联">
                        <h2>关注我们</h2>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="line"></div>
                <p>Copyright © 2024 杭州慧建智联科技有限公司版权所有 浙ICP备2021034978号-1</p>
            </div>
            <div class="footer-mobile">
                <div class="line"></div>
                <p>Copyright © 2024 <br>杭州慧建智联科技有限公司版权所有<br>浙ICP备2021034978号-1</p>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
}
</script>
<style scoped>
@import '../assets/css/footer.css';
</style>